const getMasterTariff = (provCCA, rateSched) => {
    let utilityCCA = provCCA;
    let UtilityRateSchedule = rateSched;

    if(utilityCCA === 'avce'){ // SCE
        if(UtilityRateSchedule === 'D'){return '3305200';}
        if(UtilityRateSchedule === 'D-CARE'){return '3305204';}
        if(UtilityRateSchedule === 'TOU-D-4-9PM'){return '3347221';}
        if(UtilityRateSchedule === 'TOU-D-5-8PM'){return '3347223';}
        if(UtilityRateSchedule === 'TOU-D-A'){return '3305210';}
        if(UtilityRateSchedule === 'TOU-D-B'){return '3305212';}
        if(UtilityRateSchedule === 'TOU-D-T'){return '3313108';}
        if(UtilityRateSchedule === 'TOU-EV-1'){return '3305215';}
    } else if(utilityCCA === 'ebce'){ // PG&E
        if(UtilityRateSchedule === 'E1'){return '3311850';}
        if(UtilityRateSchedule === 'E1 - CARE'){return '3311852';}
        if(UtilityRateSchedule === 'ETOU-A (3-8PM)'){return '3311864';}
        if(UtilityRateSchedule === 'ETOU-B (4-9PM)'){return '3311868';}
        if(UtilityRateSchedule === 'EV A'){return '3311874';}
        if(UtilityRateSchedule === 'EV B'){return '3311875';}
        if(UtilityRateSchedule === 'E-6/EM-TOU'){return '3311863';}
        if(UtilityRateSchedule === 'EL-TOU A CARE'){return '3311867';}
        if(UtilityRateSchedule === 'EL-TOU B CARE'){return '3311869';}
    } else if(utilityCCA === 'lce'){ // SCE
        if(UtilityRateSchedule === 'D'){return '3305260';}
        if(UtilityRateSchedule === 'D-CARE'){return '3305261';}
        if(UtilityRateSchedule === 'TOU-D-4-9PM'){return '3345895';}
        if(UtilityRateSchedule === 'TOU-D-5-8PM'){return '3345896';}
        if(UtilityRateSchedule === 'TOU-D-A'){return '3305263';}
        if(UtilityRateSchedule === 'TOU-D-B'){return '3305264';}
        if(UtilityRateSchedule === 'TOU-D-T'){return '3313107';}
        if(UtilityRateSchedule === 'TOU-EV-1'){return '3305265';}
    } else if(utilityCCA === 'mcece'){ // PG&E
        if(UtilityRateSchedule === 'E1'){return '3198679';}
        if(UtilityRateSchedule === 'E1 - CARE'){return '3338142';}
        if(UtilityRateSchedule === 'ETOU-A (3-8PM)'){return '3250709';}
        if(UtilityRateSchedule === 'ETOU-B (4-9PM)'){return '3250711';}
        if(UtilityRateSchedule === 'EL-TOU A CARE'){return '3338144';}
        if(UtilityRateSchedule === 'EL-TOU B CARE'){return '3338146';}
        if(UtilityRateSchedule === 'E-6/EM-TOU'){return '3187553';}
        if(UtilityRateSchedule === 'EV A'){return '3198701';}
        if(UtilityRateSchedule === 'EV B'){return '3198702';}
        if(UtilityRateSchedule === 'EL-6/EML-TOU CARE'){return '3338143';}
    } else if(utilityCCA === 'pce'){ // PG&E
        if(UtilityRateSchedule === 'E1'){return '3274490';}
        if(UtilityRateSchedule === 'E1 - CARE'){return '3274492';}
        if(UtilityRateSchedule === 'ETOU-A (3-8PM)'){return '3274506';}
        if(UtilityRateSchedule === 'ETOU-B (4-9PM)'){return '3274510';}
        if(UtilityRateSchedule === 'EL-TOU A CARE'){return '3274508';}
        if(UtilityRateSchedule === 'EL-TOU B CARE'){return '3274511';}
        if(UtilityRateSchedule === 'E-6/EM-TOU'){return '3274501';}
        if(UtilityRateSchedule === 'EV A'){return '3274504';}
        if(UtilityRateSchedule === 'EV B'){return '3274505';}
    } else if(utilityCCA === 'pioneerce'){ // PG&E
        if(UtilityRateSchedule === 'E1'){return '3303457';}
        if(UtilityRateSchedule === 'E1 - CARE'){return '3303459';}
        if(UtilityRateSchedule === 'ETOU-A (3-8PM)'){return '3303498';}
        if(UtilityRateSchedule === 'ETOU-B (4-9PM)'){return '3303505';}
        if(UtilityRateSchedule === 'EL-TOU A CARE'){return '3303499';}
        if(UtilityRateSchedule === 'EL-TOU B CARE'){return '3303506';}
        if(UtilityRateSchedule === 'E-6/EM-TOU'){return '3303481';}
        if(UtilityRateSchedule === 'EV A'){return '3303489';}
        if(UtilityRateSchedule === 'EV B'){return '3303490';}
    } else if(utilityCCA === 'scp'){ // PG&E
        if(UtilityRateSchedule === 'E1'){return '3200682';}
        if(UtilityRateSchedule === 'E1 - CARE'){return '3338152';}
        if(UtilityRateSchedule === 'ETOU-A (3-8PM)'){return '3250716';}
        if(UtilityRateSchedule === 'ETOU-B (4-9PM)'){return '3250717';}
        if(UtilityRateSchedule === 'EL-TOU A CARE'){return '3338154';}
        if(UtilityRateSchedule === 'EL-TOU B CARE'){return '3338156';}
        if(UtilityRateSchedule === 'E-6/EM-TOU'){return '3200688';}
        if(UtilityRateSchedule === 'EV A'){return '3200695';}
        if(UtilityRateSchedule === 'EV B'){return '3200696';}
        if(UtilityRateSchedule === 'EL-6/EML-TOU CARE'){return '3338153';}
    } else if(utilityCCA === 'vce'){ // PG&E
        if(UtilityRateSchedule === 'E1'){return '3311936';}
        if(UtilityRateSchedule === 'E1 - CARE'){return '3311938';}
        if(UtilityRateSchedule === 'E-6/EM-TOU'){return '3311947';}
        if(UtilityRateSchedule === 'ETOU-A (3-8PM)'){return '3311950';}
        if(UtilityRateSchedule === 'ETOU-B (4-9PM)'){return '3311953';}
        if(UtilityRateSchedule === 'EL-TOU A CARE'){return '3311952';}
        if(UtilityRateSchedule === 'EL-TOU B CARE'){return '3311954';}
        if(UtilityRateSchedule === 'EV A'){return '3311959';}
        if(UtilityRateSchedule === 'EV B'){return '3311960';}
    } else if (utilityCCA === 'pge'){
        if(UtilityRateSchedule === 'E1'){return '522';}
        if(UtilityRateSchedule === 'E1 - CARE'){return '3154331';}
        if(UtilityRateSchedule === 'E1 - CARE & MedBaseline'){return '3154331';} //needs to be updated
        if(UtilityRateSchedule === 'E1 - MedBaseline'){return '522';} //needs to be updated
        if(UtilityRateSchedule === 'EL-TOU A CARE'){return '3251055';} 
        if(UtilityRateSchedule === 'EL-TOU B CARE'){return '3251057';} 
        if(UtilityRateSchedule === 'ETOU-A (3-8PM)'){return '3251054';} 
        if(UtilityRateSchedule === 'ETOU-B (4-9PM)'){return '3251052';} 
        if(UtilityRateSchedule === 'EV A'){return '3162130';} 
        if(UtilityRateSchedule === 'EV B'){return '3162131';} 
        if(UtilityRateSchedule.contains('E1 - CARE & MedBaseline')||UtilityRateSchedule.contains('E1 - CARE')){return '3154331';}
        if(UtilityRateSchedule.contains('E1 - MedBaseline')){return '522';}
        if(UtilityRateSchedule.contains('E1')){return '522';}
    } else if (utilityCCA === 'sce'){
        if(UtilityRateSchedule === 'D'){return '447';}
        if(UtilityRateSchedule === 'D-SDP'){return '447';}
        if(UtilityRateSchedule === 'D-MedBaseline'){return '447';} //needs to be updated
        if(UtilityRateSchedule === 'D-CARE'){return '3153640';}
        if(UtilityRateSchedule === 'D-CARE-SDP'){return '3153640';}
        if(UtilityRateSchedule === 'D-CARE & MedBaseline'){return '3153640';} //needs to be updated
        if(UtilityRateSchedule === 'D-FERA' || UtilityRateSchedule === 'D-FERA-SDP'){return '447';} //needs to be updated - FERA
        if(UtilityRateSchedule === 'TOU-D-A'|| UtilityRateSchedule === 'TOU-D-A-CARE'|| UtilityRateSchedule === 'TOU-D-A-FERA'){return '3209767';} // needs to be updated / split up
        if(UtilityRateSchedule === 'TOU-D-B'|| UtilityRateSchedule === 'TOU-D-B-CARE'|| UtilityRateSchedule === 'TOU-D-B-FERA'){return '3209768';} // needs to be updated / split up
        if(UtilityRateSchedule === 'TOU-D-T'|| UtilityRateSchedule === 'TOU-D-T-CARE'|| UtilityRateSchedule === 'TOU-D-T-FERA' || UtilityRateSchedule === 'TOU-D-T Med Baseline'|| UtilityRateSchedule === 'TOU-DT-SDP'){return '452';}// needs to be updated / split up
        if(UtilityRateSchedule === 'TOU-EV-1' || UtilityRateSchedule === 'TOU-EV-1-CARE'|| UtilityRateSchedule === 'TOU-EV-1-FERA'){return '456';} // needs to be updated / split up
        if(UtilityRateSchedule === 'TOU-D-4-9PM'|| UtilityRateSchedule === 'TOU-D-4-9PM-CARE' || UtilityRateSchedule === 'TOU-D-4-9PM-FERA' || UtilityRateSchedule === 'TOU-D-4-9PM-SDP'){return '3300822';} // needs to be updated / split up
        if(UtilityRateSchedule === 'TOU-D-5-8PM'|| UtilityRateSchedule === 'TOU-D-5-8PM-CARE' || UtilityRateSchedule === 'TOU-D-5-8PM-FERA' || UtilityRateSchedule === 'TOU-D-5-8PM-SDP'){return '3300823';} // needs to be updated / split up
    }
    return null;
};

export default getMasterTariff;
